import { Component, EventEmitter, Output } from '@angular/core';
import { ConfigurationComponent, PointConfig} from '../models/geometry.model';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-point-configuration',
    templateUrl: './point-configuration.component.html',
    styleUrls: ['./point-configuration.component.scss'],
    standalone: false
})
export class PointConfigurationComponent implements ConfigurationComponent<PointConfig> {
    model: PointConfig;
    @Output('modelChange')
    saveChange: Observable<any> = new EventEmitter();
    form: FormGroup = new FormGroup({
        latitude: new FormControl(),
        longitude: new FormControl(),
        title: new FormControl(),
        z: new FormControl(),
        geodesic: new FormControl(),
        buffer: new FormControl()
    });

    ngAfterViewInit() {
        this._createControl();
    }

    save() {
        this.model.title = this.form.controls.title.value;
        this.model.xContextLocation = this.form.controls.longitude.value;
        this.model.yContextLocation = this.form.controls.latitude.value;
        this.model.geodesic = this.form.controls.geodesic.value;
        this.model.zContextLocation = this.form.controls.z.value;
        this.model.bufferFt = this.form.controls.buffer.value;

        (this.saveChange as EventEmitter<any>).emit();
    }

    cancel() {
        (this.saveChange as EventEmitter<any>).emit();
    }

    public _createControl() {
        this.form = new FormGroup({
            latitude: new FormControl(this.model.yContextLocation),
            longitude: new FormControl(this.model.xContextLocation),
            title: new FormControl(this.model.title),
            z: new FormControl(this.model.zContextLocation),
            geodesic: new FormControl(this.model.geodesic),
            buffer: new FormControl(this.model.bufferFt)
        });
    }
}
